var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:`arrow ${_vm.direction}`,style:(`border-color: ${_vm.color}; padding: ${_vm.size};`)})
}
var staticRenderFns = []

export { render, staticRenderFns }